module.exports = __webpack_public_path__ + "static/media/publish_important.385b7926.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/publish_important.svg
// module id = 414
// module chunks = 0